<template>
  <!-- Dialog -->
  <div>
    <DialogConfirmChange
      :isOpen="confirmDialog"
      @update:isOpen="confirmDialog = $event"
      @onConfirm="onSubmit()"
    />

    <v-dialog v-model="dialog" width="600" persistent>
      <v-form
        ref="form"
        v-model="validForm"
        lazy-validation
        class="pa-4"
        style="background-color: #fff"
      >
        <v-layout justify-center>
          <v-flex shrink class="d-flex flex-column">
            <!-- avatar -->
            <v-avatar size="132" class="mb-4">
              <v-img
                min-height="132"
                min-width="132"
                max-width="132"
                max-height="132"
                class="profile-icon mr-2"
                :src="imageUrl ? imageUrl : formInput.FullPhotoUrl"
              >
                <template v-slot:placeholder>
                  <v-sheet
                    color="#E5E5E5"
                    height="100%"
                    style="border-radius: 100%"
                  ></v-sheet>
                </template>
              </v-img>
            </v-avatar>
            <v-btn
              style="margin-top: -50px; margin-left: 80px"
              fab
              small
              width="35"
              height="35"
              color="#FFFFFF"
              class="mr-2"
              @click="onAddImage"
            >
              <v-icon color="var(--theme-color-one)">add</v-icon>
            </v-btn>
            <input
              type="file"
              accept="image/png, image/jpeg, image/jpg, image/gif"
              ref="img-uploader"
              hidden
              @change="onUpload"
            />
          </v-flex>
        </v-layout>

        <div class="font-18 font-w-600 mb-4">ข้อมูลส่วนตัว</div>
        <TextField
          label="ชื่อ"
          :outlined="true"
          :solo="false"
          :hideDetails="false"
          :required="true"
          :rules="[(v) => !!v || 'กรุณาระบุชื่อ']"
          width="100%"
          :value="formInput.FirstName"
          @onChange="formInput.FirstName = $event"
        ></TextField>

        <TextField
          label="นามสกุล"
          :outlined="true"
          :solo="false"
          :hideDetails="false"
          :required="true"
          :rules="[(v) => !!v || 'กรุณาระบุนามสกุล']"
          width="100%"
          :value="formInput.LastName"
          @onChange="formInput.LastName = $event"
        ></TextField>

        <!-- <TextField
        label="Company ID & Name"
        :outlined="true"
        :solo="false"
        :hideDetails="false"
        :readonly="true"
        :rules="[(v) => !!v || 'กรุณาระบุ Company ID & Name']"
        width="100%"
        :value="form.CompanyName"
        @onChange="form.CompanyName = $event"
      ></TextField> -->

        <!-- <TextField
        label="Branch ID & Name"
        :outlined="true"
        :solo="false"
        :hideDetails="false"
        :readonly="true"
        :rules="[(v) => !!v || 'กรุณาระบุ Branch ID & Name']"
        width="100%"
        :value="form.BranchName"
        @onChange="form.BranchName = $event"
      ></TextField> -->

        <TextField
          label="ตำแหน่ง"
          :outlined="true"
          :solo="false"
          :hideDetails="false"
          :readonly="true"
          width="100%"
          :value="formInput.Role__c"
          @onChange="formInput.Role__c = $event"
          :disabled="isDisabled"
        ></TextField>

        <!-- <TextField
        label="โทรศัพท์"
        :outlined="true"
        :solo="false"
        :hideDetails="false"
        :required="true"
        :rules="[(v) => !!v || 'กรุณาระบุโทรศัพท์']"
        width="100%"
        :value="form.Phone"
        @onChange="form.Phone = $event"
      ></TextField> -->

        <TextField
          label="เบอร์โทร"
          :outlined="true"
          :solo="false"
          :hideDetails="false"
          :required="true"
          :rules="[
            (v) => !!v || 'กรุณากรอกเบอร์โทร',
            (v) => /^[0-9\b]+$/.test(v) || 'กรุณากรอกเฉพาะตัวเลข',
            (v) => (v && v.length == 10) || 'กรุณากรอกเบอร์โทรให้ครบ 10 หลัก',
          ]"
          width="100%"
          :value="formInput.MobilePhone ? formInput.MobilePhone.replace(/(\d{3})(\d{6}|\d{7})/, '$1-$2') : '' "
          @onChange="formInput.MobilePhone = $event"
          :readonly="true"
          :disabled="isDisabled"
        ></TextField>

        <TextField
          label="อีเมล"
          :outlined="true"
          :solo="false"
          :hideDetails="false"
          :required="true"
          :rules="[
            (v) => !!v || 'กรุณากรอกอีเมลให้ถูกต้อง',
            (v) =>
              /([A-Za-z]|[0-9])+@([A-Za-z]|[0-9])+\.([A-Za-z]|[0-9])+/.test(
                v
              ) || 'กรุณากรอกอีเมลให้ถูกต้อง',
          ]"
          width="100%"
          :value="formInput.Email"
          @onChange="formInput.Email = $event"
        ></TextField>

        <!-- <TextField
        label="LINE ID"
        :outlined="true"
        :solo="false"
        :hideDetails="false"
        width="100%"
        :value="form.LINE_ID__c"
        @onChange="form.LINE_ID__c = $event"
      ></TextField> -->

        <v-row>
          <v-col cols="6">
            <v-btn
              color="#637381"
              depressed
              block
              :dark="true"
              class="ml-2"
              @click="onCancel"
              outlined
            >
              ยกเลิก
            </v-btn>
          </v-col>

          <v-col cols="6">
            <v-btn
              color="var(--theme-color-one)"
              depressed
              :dark="validForm"
              :disabled="!validForm"
              @click="confirmDialog = true"
              block
            >
              บันทึก
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import TextField from "./Input/TextField.vue";
import { controllerName, mainSite, logOutUrl } from "../store/constants";
import { mapState } from "vuex";
import DialogConfirmChange from "./DialogConfirmChange.vue";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      validForm: true,
      tmpFirstName: "",
      tmpLastName: "",
      formInput: {
        FirstName: "",
        LastName: "",
        CompanyName: "",
        BranchName: "",
        Role__c: "",
        Phone: "",
        MobilePhone: "",
        Email: "",
        LINE_ID__c: "",
        FullPhotoUrl: "",
        SmallPhotoUrl: "",
      },
      imageUrl: "",
      fileInput: null,
      fileType: "",
      imgBase64: null,
      isEditSuccess: false,
      confirmDialog: false,
    };
  },
  // created() {
  //   this.formInput = this.formData;
  //   this.tmpFirstName = this.formData.FirstName;
  //   this.tmpLastName = this.formData.LastName;
  // },
  watch: {
    formData: {
      handler: function (newVal, oldVal) {
        console.log("form change: ", newVal);
        if (newVal) {
          this.formInput.FirstName = newVal.FirstName;
          this.formInput.LastName = newVal.LastName;
          this.formInput.Role__c = newVal.Role__c;
          this.formInput.MobilePhone = newVal.MobilePhone;
          this.formInput.FullPhotoUrl = newVal.FullPhotoUrl;
          this.formInput.Email = newVal.Email;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.Auth.userInfo,
    }),
    isDisabled() {
      return this.formInput.Role__c !== undefined;
    },
  },
  methods: {
    onCancel() {
      console.log("formData: ", this.formData);
      // this.formInput = this.formData;
      // this.tmpFirstName = this.formInput.FirstName;
      // this.tmpLastName = this.formInput.LastName;
      this.formInput.FirstName = this.formData.FirstName;
      this.formInput.LastName = this.formData.LastName;
      this.formInput.Role__c = this.formData.Role__c;
      this.formInput.MobilePhone = this.formData.MobilePhone;
      this.formInput.FullPhotoUrl = this.formData.FullPhotoUrl;
      this.formInput.Email = this.formData.Email;
      console.log("form: ", this.formInput);
      // force update component
      // this.$forceUpdate();

      this.$emit("close");
    },
    onSubmit() {
      // todo : call api
      this.$refs.form.validate();
      if (!this.validForm) return;

      // if (this.tmpFirstName) {
      //   this.formInput.FirstName = this.tmpFirstName;
      // }
      // if (this.tmpLastName) {
      //   this.formInput.LastName = this.tmpLastName;
      // }
      // console.log("form: ", this.formInput);
      this.$store.commit("General/setLoading");
      this.$lc.callApex(
        `${controllerName}.updateUserInfo`,
        { data: this.formInput },
        (res, event) => {
          // console.log("res: ", res);
          // console.log("event: ", event);

          if (event.status && event.statusCode === 200 && res) {
            this.$store.commit("Auth/setUserInfo", res);
            // this.form = res;
            this.isEdit = false;
            this.$emit("getUserInfo");
            this.isEditSuccess = true;
          }
          this.$store.commit("General/setLoading", false);
        }
      );

      if (this.imgBase64) {
        let updateUserPhoto = {
          data: {
            ContentDownloadUrl: this.imgBase64,
            FileType: this.fileType, // png, jpg, jpeg or gif
          },
        };
        console.log(updateUserPhoto);
        this.$store.commit("General/setLoading");
        this.$lc.callApex(
          `${controllerName}.updateUserPhoto`,
          updateUserPhoto,
          (res, event) => {
            console.log(res);
            console.log(event);

            this.$store.commit("General/setLoading", false);
          }
        );
      }

      this.$emit("accept");
    },
    onAddImage() {
      return this.$refs["img-uploader"].click();
    },
    onUpload(file) {
      console.log("DEBUG onUpload : ");
      console.log(file);
      this.fileInput = file.target.files[0];
      this.fileType = this.fileInput.name
        .split(".")[this.fileInput.name.split(".").length - 1].toUpperCase();

      console.log(this.fileInput);
      let reader = new FileReader();

      this.$store.commit("General/setLoading");

      reader.onload = (output) => {
        this.imageUrl = output.target.result;
        this.imgBase64 = this.imageUrl.split(",")[1];
        this.$refs["img-uploader"].value = "";
        this.$store.commit("General/setLoading", false);
      };

      if (this.fileInput) {
        reader.readAsDataURL(this.fileInput);
      }
    },
  },
  components: { TextField, DialogConfirmChange },
};
</script>

<style></style>
